module.exports = __webpack_public_path__ + "static/media/confirm-result-herdy-group-1.12dd2158.svg";